var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.computedTag,{tag:"component",staticClass:"button-fill",class:{
        active: _vm.active,
        [_vm.color]: _vm.color,
        disabled: _vm.isDisabled,
        [_vm.size]: _vm.size,
        uppercase: _vm.uppercase,
    },attrs:{"aria-disabled":_vm.isDisabled,"disabled":_vm.isDisabled,"href":_vm.href,"to":_vm.to,"title":_vm.disabledLabelText},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }